/* eslint-disable react/prop-types */
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import InfoIcon from "@mui/icons-material/Info";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import PreviewIcon from "@mui/icons-material/Preview";
import PublicIcon from "@mui/icons-material/Public";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SafetyCheckIcon from "@mui/icons-material/SafetyCheck";
import VerifiedIcon from "@mui/icons-material/Verified";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessIcon from "@mui/icons-material/Business";
import CustomTabPanel from "components/CustomPanel/customPanel";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

import {
  Box,
  Button,
  Grid,
  Pagination,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Tab,
  Tabs,
  Typography,
  Link,
} from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import Footer from "components/Footer";
import IconDownload from "components/IconDownload";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Textarea from "components/Textarea";
import { Fragment, useEffect, useMemo, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { JsonTool } from "utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useQuery } from "../../hooks/useQuery";
import {
  API_ROUTES,
  API_ROUTES_V2,
  checkGroupUser,
  ID_GROUP_CAPTINH,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  API_URL_DOWNLOAD,
  checkUrlTep,
} from "../../utils/constants";
import { DicBoTieuChiState } from "states";
import useAuth from "hooks/useAuth";
import AssignmentIcon from "@mui/icons-material/Assignment";
import dayjs from "dayjs";
import { DownloadIcon } from "@primer/octicons-react";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,#0c3483 0%,#a2b6df 50%,#6b8cce 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,#0c3483 0%,#a2b6df 50%,#6b8cce 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 36,
  height: 36,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage: "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
  }),
}));

const ColorlibStepIcon = (iconNumber) => (props) => {
  const { active, completed, className } = props;

  const icons = {
    1: <Diversity2Icon />,
    2: <RocketLaunchIcon />,
    3: <EmojiEmotionsIcon />,
    4: <LocalGroceryStoreIcon />,
    5: <LocalLibraryIcon />,
    6: <PreviewIcon />,
    7: <AutoFixHighIcon />,
    8: <PlaylistAddCheckCircleIcon />,
    9: <VerifiedIcon />,
    10: <PublicIcon />,
    11: <SafetyCheckIcon />,
    12: <ReceiptLongIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(iconNumber)] ? icons[String(iconNumber)] : <InfoIcon />}
    </ColorlibStepIconRoot>
  );
};
function DetailChamDiemCapTinh() {
  const { id, thanhvien } = useQuery();
  const axiosPrivateInstance = useAxiosPrivate();
  const setAlert = useSetRecoilState(AlertState);
  const [sanPham, setSanPham] = useState(); //state thông tin sản phẩm đăng ký
  const [isLoading, setIsLoading] = useState(false); //loading data
  const [activeStep, setActiveStep] = useState({
    //các step theo từng tab
    0: 0,
    1: 0,
    2: 0,
  });
  const [dataBoTieuChi, setBoTieuChi] = useState([]); // danh sách bộ tiêu chí đã chia nhóm -nhóm bộ
  const [dataChamDiem, setDataChamDiem] = useState(); //lấy hồ sơ chấm điểm trả về thông tin các điểm đã chấm trước đó
  const [dataChamDiemHoiDongCapHuyen, setDataChamDiemHoiDongCapHuyen] =
    useState(); //lấy hồ sơ chấm điểm hội đồng cấp huyện
  const [showYKien, setShowYKien] = useState(false); //state filed ý kiến đánh giá
  const listBoTieuChiNhom = useRecoilValue(DicBoTieuChiState); //danh sách bộ tiêu chí chứa nhombotieuchi_id để kiểm tra 1 nhombotieuchi chỉ có thể có 1 tiêu chí được chọn
  const [pageQuestion, setPageQuestion] = useState({
    //state page theo tab - step => tab[step] = page
    0: {},
    1: {},
    2: {},
  });

  //
  const [tab, setTab] = useState(0);
  const [tabSanPham, setTabSanPham] = useState(0);
  const [steps, setSteps] = useState([]); //danh sách các steps của 1 tab
  const { user } = useAuth();
  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //kiểm tra nhóm người dùng là 9 - cấp tỉnh
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  useEffect(() => {
    const fetchDataDangKySanPham = (id, thanhvien, listNhomTieuChi) => {
      setIsLoading(true);
      axiosPrivateInstance
        .get(API_ROUTES_V2.PHIEUDANGKY + "/" + id)
        .then((response) => {
          const data = response.data;
          setSanPham(data);
          setDataChamDiemHoiDongCapHuyen(data.hoidong_caphuyen);
          if (data) {
            if (data.nhomsanpham_id) {
              axiosPrivateInstance
                .get(API_ROUTES.BOTIEUCHI, {
                  params: {
                    nhomsanpham: data.nhomsanpham_id,
                    nhom: true,
                  },
                })
                .then((res1) => {
                  const data = res1.data[0]?.nhom;
                  //bỏ rỗng
                  const nhomNoEmpty = data?.filter(
                    (nhom) =>
                      !nhom?.nhombotieuchi?.every(
                        (tieuchi) => tieuchi?.botieuchi?.length === 0
                      )
                  );
                  setBoTieuChi(nhomNoEmpty);
                  //tạo dic cho phân trang
                  let dicPageValues = { 0: {}, 1: {}, 2: {} };
                  const indexTabs = [0, 1, 2];
                  indexTabs.forEach((index) => {
                    const nhomBoTieuChi =
                      nhomNoEmpty?.filter((nhom) => nhom?.nhom == index + 1) ||
                      [];
                    nhomBoTieuChi?.forEach((nhomBo, idx) => {
                      //tab, step => page
                      dicPageValues[String(index)][String(idx)] = 1;
                    });
                  });
                  setPageQuestion(dicPageValues);
                  //data ban đầu của steps với tạo mới ban đầu là tab =0 có nhom=1
                  const dataStep = nhomNoEmpty?.filter((item) => {
                    if (item?.nhom == 1)
                      return { id: item?.id, ten: item?.ten };
                  });
                  if (dataStep && dataStep.length > 0) {
                    setSteps(dataStep);
                  }
                });
            }
            if (
              data.chamdiem &&
              listNhomTieuChi &&
              thanhvien &&
              Object.values(listNhomTieuChi).length > 0
            ) {
              axiosPrivateInstance
                .get(API_ROUTES.GETHOSOCHAMDIEMCAPTINH, {
                  params: {
                    chamdiem: data.chamdiem[0]?.id,
                    thanhvien: thanhvien,
                  },
                })
                .then((res) => {
                  const listDataDiem = res.data?.data[0];
                  let dicDiem = {};
                  //thêm nhombotieuchi_id cho hồ sơ chấm điểm
                  listDataDiem?.botieuchi?.forEach(
                    (item) =>
                      (dicDiem[item?.botieuchi] = {
                        ...item,
                        nhomtieuchi_id:
                          listNhomTieuChi[item?.botieuchi]?.nhombotieuchi_id,
                      })
                  );
                  setDataChamDiem({
                    ...listDataDiem,
                    botieuchi: dicDiem,
                  });
                });
            }
          }
        })
        .catch((error) => {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    if (
      id &&
      listBoTieuChiNhom &&
      Object.values(listBoTieuChiNhom).length > 0
    ) {
      fetchDataDangKySanPham(id, thanhvien, listBoTieuChiNhom);
    }
    return () => {
      setSanPham(null);
    };
  }, [id, thanhvien, listBoTieuChiNhom]);

  //các trường thông tin của form đăng ký sản phẩm cần đánh giá
  const dataInfor = useMemo(() => {
    const result = [
      {
        key: "nhomsanpham_ten",
        name: "Bộ sản phẩm",
      },
      {
        key: "phanloai_ten",
        name: "Nhóm sản phẩm",
      },
      {
        key: "sanpham_ten",
        name: "Tên sản phẩm",
      },
      {
        key: "sanpham_ma",
        name: "Mã số sản phẩm",
      },
      {
        key: "chuthe_ten",
        name: "Tên chủ thể sản xuất",
      },
      {
        key: "chuthe_diachi",
        name: "Địa chỉ",
      },
      {
        key: "chuthe_dienthoai",
        name: "Điện thoại",
      },
      {
        key: "chuthe_email",
        name: "Email",
      },
      {
        key: "chuthe_nguoidaidienphapluat",
        name: "Đại diện pháp luật",
      },
      {
        key: "chuthe_loaihinh",
        name: "Loại hình",
      },
      {
        key: "chuthe_dantoc",
        name: "Dân tộc",
      },
      {
        key: "chuthe_gioitinh",
        name: "Giới tính",
      },
    ];
    return result;
  }, []);
  const dataContent = useMemo(() => {
    const result = [
      {
        key: "noidung_nguongoc",
        name: "Sử dụng nguyên liệu địa phương:",
      },
      {
        key: "noidung_laodong",
        name: "Sử dụng lao động địa phương:",
      },
      {
        key: "noidung_ytuong",
        name: "Nguồn gốc ý tưởng sản phẩm:",
      },
      {
        key: "noidung_bansac",
        name: "Bản sắc/Trí tuệ địa phương:",
      },
      {
        key: "noidung_khac",
        name: "Nội dung khác:",
      },
    ];
    return result;
  }, []);
  const handleNext = () => {
    //bấm nút tiếp theo của steps
    let newTab = tab;
    let newTabStep = activeStep[tab] + 1;
    if (tab == 2 && activeStep[2] == steps.length - 1) {
      //khi ở step cuối cùng của tab cuối
      newTabStep = activeStep[tab];
      setShowYKien(true);
    } else if (activeStep[tab] == steps?.length - 1) {
      //có xuất hiện step tiếp theo hoặc tab tiếp theo
      showYKien && setShowYKien(false);
      newTab = tab + 1;
      const dataStep = dataBoTieuChi?.filter((item) => {
        if (item?.nhom == newTab + 1) return { id: item?.id, ten: item?.ten };
      });
      setSteps(dataStep);
      newTabStep = 0;
      setTab(newTab);
    }
    setActiveStep((prevActiveStep) => ({
      ...prevActiveStep,
      [newTab]: newTabStep,
    }));
  };

  const handleBack = () => {
    //trở về steps kế trước hoặc nếu ở vị trí index =0 của  steps thì trở về step cuối của tab trước đó
    let newTab = tab;
    let newTabStep = activeStep[tab] - 1;
    if (activeStep[tab] == 0) {
      //khi tab là ở step index = 0 thì trở về step cuối cùng tab trước
      newTab = tab - 1;
      const dataStep = dataBoTieuChi?.filter((item) => {
        if (item?.nhom == newTab + 1) return { id: item?.id, ten: item?.ten };
      });
      setSteps(dataStep);
      newTabStep = dataStep?.length - 1;
      setTab(newTab);
    }
    setActiveStep((prevActiveStep) => ({
      ...prevActiveStep,
      [newTab]: newTabStep,
    }));
  };

  const handleReset = () => {
    //khi ở nội dung ý kiến đánh giá trở về phía step cuối của tạp cuối
    setActiveStep((prev) => ({
      ...prev,
      2: steps.length - 1,
    }));
    setShowYKien(false); // ẩn form ý kiến đi
  };

  const handleChangePage = (e, page) => {
    // thay đổi câu hỏi và trả lời trong step, tab hiện tại
    setPageQuestion((prev) => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        [activeStep[tab]]: page,
      },
    }));
  };

  const handleChangeTabSanPham = (event, newValue) => {
    setTabSanPham(newValue);
  };
  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
    const dataStep = dataBoTieuChi?.filter((item) => {
      if (item?.nhom == newValue + 1) return { id: item?.id, ten: item?.ten };
    }); //thay đổi danh sách steps
    setSteps(dataStep);
    showYKien && setShowYKien(false); //nếu đang show form ý kiến thì ẩn đi
  };
  const listNhomTieuChi = useMemo(() => {
    // danh sách các câu hỏi thuộc step đang active
    const list = dataBoTieuChi
      ?.filter((item) => item?.nhom == tab + 1)
      ?.[activeStep[tab]]?.nhombotieuchi?.filter(
        (nhom) => nhom?.botieuchi?.length > 0
      );
    return list;
  }, [dataBoTieuChi, activeStep, tab]);

  const nhomBoTieuChi = useMemo(() => {
    // câu hỏi đươc chọn show lên theo dicPage đã lập dạng dict[tabActive][stepActive] = pageActive
    const idx = pageQuestion[tab]?.[activeStep[tab]] - 1;
    const list = listNhomTieuChi?.[idx];
    return list;
  }, [listNhomTieuChi, pageQuestion, activeStep, tab]);

  const totalPoint = useMemo(() => {
    //lấy tất cả điểm đã chấm ra tính tổng
    let totalScore = 0;
    if (dataChamDiem && dataChamDiem.botieuchi) {
      Object.values(dataChamDiem.botieuchi).forEach((item) => {
        if (item && item.diem) {
          totalScore += item?.diem;
        }
      });
    }
    return totalScore;
  }, [dataChamDiem]);

  //change file
  const handleErrorDownload = (error) => {
    setAlert({
      alert: true,
      message: error,
      type: "error",
    });
  };
  //handle Steps
  const handleStepClick = (stepIndex) => () => {
    setActiveStep((prev) => ({
      ...prev,
      [tab]: stepIndex,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading ? (
        <div className="w-full flex items-center justify-center mt-12">
          <LoadingCircle size={46} />
        </div>
      ) : (
        <>
          <MDBox
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginTop: "0.5rem",
              borderColor: "divider",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
            }}
          >
            <Tabs
              value={tabSanPham}
              onChange={handleChangeTabSanPham}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              centered
            >
              <Tab
                icon={<BusinessIcon />}
                label="THÔNG TIN SẢN PHẨM"
                {...JsonTool.a11yProps(0)}
                wrapped
              />
              <Tab
                icon={<ArticleIcon />}
                label="TỆP ĐÍNH KÈM"
                {...JsonTool.a11yProps(1)}
              />
              {(isHoiDong ||
                isGroupNumberNine ||
                isGroupNumberOne ||
                isGroupNumberSeven ||
                isGroupNumberEight) && (
                <Tab
                  icon={<AssignmentIcon />}
                  label="NỘI DUNG BÁO CÁO CẤP XÃ"
                  {...JsonTool.a11yProps(2)}
                />
              )}
              {(isHoiDong || isGroupNumberNine || isGroupNumberOne) && (
                <Tab
                  icon={<PublishedWithChangesIcon />}
                  label="ĐÁNH GIÁ TỪ CẤP HUYỆN"
                  {...JsonTool.a11yProps(3)}
                />
              )}
            </Tabs>
            <CustomTabPanel value={tabSanPham} index={0}>
              <Grid container spacing={1}>
                {dataInfor.map((item, index) => (
                  <Fragment key={item?.key + index + "inforchamdiem"}>
                    <Grid item xs={12} md={3} lg={2}>
                      <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
                    </Grid>
                    <Grid item xs={12} md={9} lg={4}>
                      <Typography fontSize={"1rem"} fontWeight={700}>
                        {sanPham?.[item?.key]
                          ? sanPham?.[item?.key]
                          : "Đang cập nhập..."}
                      </Typography>
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={1}>
              <Grid item xs={12}>
                {sanPham?.tepdinhkem_phieudangky &&
                sanPham?.tepdinhkem_phieudangky?.length > 0 ? (
                  <Grid container p="0 1rem 1rem 1rem">
                    <Grid
                      container
                      style={{
                        color: "#000000",
                        backgroundColor: "#c6e3fa",
                      }}
                      fontSize={"1rem"}
                      fontWeight={600}
                      pb={"0.5rem"}
                      m={"0.5rem 0"}
                      spacing={1}
                      borderBottom={"2px solid #3F51B5"}
                    >
                      <Grid item xs={2}>
                        STT
                      </Grid>
                      <Grid item xs={8}>
                        Tên tệp đính kèm
                      </Grid>
                      <Grid item xs={2}>
                        Tải về
                      </Grid>
                    </Grid>
                    {sanPham?.tepdinhkem_phieudangky?.map((tep, index) => (
                      <Grid
                        container
                        key={tep?.id + index + "tepdinhkem"}
                        style={{ color: "#000000" }}
                        fontSize={"1rem"}
                        borderBottom={"1px solid #d6d6d6"}
                        pb={"0.5rem"}
                        mb={"0.5rem"}
                        ml={0}
                        spacing={1}
                      >
                        <Grid item xs={2}>
                          {index + 1}
                        </Grid>
                        <Grid item xs={8}>
                          {tep?.tentepdinhkem}
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          style={{ paddingTop: "0px" }}
                        >
                          <Typography variant="h5" color="info">
                            <Link
                              target="_blank"
                              href={
                                API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)
                              }
                            >
                              <DownloadIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    p="1rem"
                    height="100%"
                  >
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Không có thông tin Tệp đính kèm
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={2}>
              <Grid container spacing={1}>
                {dataContent.map((item, index) => (
                  <Fragment key={item?.key + index + "inforchamdiem"}>
                    <Grid item xs={12} md={3} lg={3}>
                      <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
                    </Grid>
                    <Grid item xs={12} md={9} lg={9}>
                      <Typography fontSize={"1rem"} fontWeight={700}>
                        {sanPham?.[item?.key]
                          ? sanPham?.[item?.key]
                          : "Đang cập nhập..."}
                      </Typography>
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={3}>
              <Grid
                container
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
                p="1rem"
                height="100%"
              >
                {dataChamDiemHoiDongCapHuyen?.length > 0 ? (
                  <>
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Ngày đánh giá:{" "}
                      {dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).isValid()
                        ? dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).format(
                            "DD/MM/YYYY"
                          )
                        : dataChamDiemHoiDongCapHuyen[0].ngaycham}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Tổng số điểm: {dataChamDiemHoiDongCapHuyen[0].tongdiem}{" "}
                      điểm
                    </Typography>
                  </>
                ) : (
                  <Typography
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "500",
                      lineHeight: "1.5rem",
                      color: "black",
                    }}
                  >
                    Cấp huyện chưa chấm xong hoặc chưa tổng hợp điểm từ các
                    phiếu thành viên chấm!
                  </Typography>
                )}
              </Grid>
            </CustomTabPanel>
          </MDBox>
          <MDBox
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginTop: "0.5rem",
              borderColor: "divider",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
            }}
          >
            <Tabs
              value={tab}
              onChange={handleChangeTab}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab
                // icon={<Diversity2Icon />}
                label="PHẦN A - SẢN PHẨM VÀ SỨC MẠNH CỦA CỘNG ĐỒNG (40 ĐIỂM)"
                {...JsonTool.a11yProps(0)}
              />
              <Tab
                // icon={<LocalGroceryStoreIcon />}
                label="PHẦN B - KHẢ NĂNG TIẾP THỊ (25 ĐIỂM)"
                {...JsonTool.a11yProps(1)}
              />
              <Tab
                // icon={<VerifiedIcon />}
                label="PHẦN C - CHẤT LƯỢNG SẢN PHẨM (35 ĐIỂM)"
                {...JsonTool.a11yProps(2)}
              />
            </Tabs>
          </MDBox>
          <Box mb={4}>
            <MDBox
              sx={{
                height: "1rem",
                alignItems: "center",
                position: "relative",
                display: "flex",
              }}
              mt={2}
            >
              <div className="mr-4 text-lg">Tổng điểm: </div>
              <div className="relative flex-1 flex items-center">
                <div className="absolute bg-slate-200 w-full h-4 rounded-full"></div>
                <div
                  className={`absolute h-4 rounded-full`}
                  style={{
                    width: `${totalPoint > 100 ? 100 : totalPoint}%`,
                    transition: "width 1s",
                    backgroundImage:
                      "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
                  }}
                ></div>
                <div
                  className={`absolute left-[45%] text-sm ${
                    totalPoint > 45 ? "text-slate-400" : "text-slate-700"
                  }`}
                >
                  {totalPoint}/100
                </div>
              </div>
            </MDBox>
            {showYKien ? (
              <Grid
                container
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "0.5rem",
                  padding: "0.75rem 1.5rem",
                  marginTop: "0.5rem",
                }}
              >
                <Grid item xs={12}>
                  <Typography sx={{ mt: 2, mb: 1 }}>Ý kiến đánh giá</Typography>
                  <Box sx={{ flex: "1 1 auto" }}>
                    <Textarea
                      maxRows={10}
                      placeholder="Nhập đánh giá"
                      maxLength={10000}
                      minRows={5}
                      defaultValue={dataChamDiem?.ykiendanhgia || ""}
                      style={{
                        overflowY: "scroll",
                      }}
                      readOnly={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    paddingTop: "0.5rem",
                    borderTop: "1px solid #d6d6d6",
                  }}
                >
                  <Typography sx={{ textAlign: "center" }}>
                    Tệp đính kèm
                  </Typography>
                  <>
                    {dataChamDiem?.tepdinhkem &&
                    dataChamDiem?.tepdinhkem?.length > 0 ? (
                      <Grid container p="0 1rem 1rem 1rem">
                        <Grid
                          container
                          style={{
                            color: "#000000",
                            backgroundColor: "#c6e3fa",
                          }}
                          fontSize={"1rem"}
                          fontWeight={600}
                          pb={"0.5rem"}
                          m={"0.5rem 0"}
                          spacing={1}
                          borderBottom={"2px solid #3F51B5"}
                        >
                          <Grid item xs={2}>
                            STT
                          </Grid>
                          <Grid item xs={8}>
                            Tên tệp đính kèm
                          </Grid>
                          <Grid item xs={2}>
                            Tải về
                          </Grid>
                        </Grid>
                        {dataChamDiem?.tepdinhkem?.map((tep, index) => (
                          <Grid
                            container
                            key={tep?.id + index + "tepdinhkem"}
                            style={{ color: "#000000" }}
                            fontSize={"1rem"}
                            borderBottom={"1px solid #d6d6d6"}
                            pb={"0.5rem"}
                            mb={"0.5rem"}
                            ml={0}
                            spacing={1}
                          >
                            <Grid item xs={2}>
                              {index + 1}
                            </Grid>
                            <Grid item xs={8}>
                              {tep?.tentepdinhkem}
                            </Grid>
                            <Grid
                              item
                              xs={2}
                              display={"flex"}
                              alignItems={"center"}
                              justifyContent={"center"}
                              style={{ paddingTop: "0px" }}
                            >
                              <Typography variant="h5" color="info">
                                <Link
                                  target="_blank"
                                  href={
                                    API_URL_DOWNLOAD +
                                    checkUrlTep(tep?.tepdinhkem)
                                  }
                                >
                                  <DownloadIcon />
                                </Link>
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Grid
                        container
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        p="1rem"
                        height="100%"
                      >
                        <Typography
                          style={{
                            fontSize: "1.25rem",
                            fontWeight: "500",
                            lineHeight: "1.5rem",
                            color: "black",
                          }}
                        >
                          Không có thông tin Tệp đính kèm
                        </Typography>
                      </Grid>
                    )}
                  </>
                </Grid>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Button onClick={handleReset} color="inherit">
                    Trở về
                  </Button>
                </Box>
              </Grid>
            ) : (
              <>
                {steps && steps.length > 0 && (
                  <MDBox
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "0.5rem",
                      padding: "0.75rem 1.5rem",
                    }}
                    mt={2}
                  >
                    <Stepper
                      alternativeLabel
                      activeStep={activeStep?.[tab] || 0}
                      connector={<ColorlibConnector />}
                    >
                      {steps.map((label, index) => (
                        <Step
                          key={label?.id + "tieude"}
                          onClick={handleStepClick(index)}
                          sx={{
                            cursor: "pointer",
                            ".Mui-disabled": { cursor: "pointer !important" },
                          }}
                        >
                          <StepLabel
                            StepIconComponent={ColorlibStepIcon(label?.id)}
                          >
                            {label?.ten}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Fragment>
                      {listNhomTieuChi && listNhomTieuChi.length > 0 ? (
                        <MDBox
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "0.5rem",
                          }}
                          mt={2}
                        >
                          <div id="q_question" className="flex min-h-[260px]">
                            <div
                              id="q_contentQuestion"
                              className="flex flex-1 flex-col gap-1"
                            >
                              <h5
                                id="q_count"
                                className="text-sm text-gray-600 italic"
                              >
                                Câu {pageQuestion[tab]?.[activeStep[tab]]} trong
                                tổng {listNhomTieuChi?.length || 0}
                              </h5>
                              <p
                                id="q_question"
                                className="text-base font-bold"
                              >
                                {nhomBoTieuChi?.ten}
                              </p>
                              <ol className="mt-1 flex flex-wrap gap-x-7 gap-y-3">
                                {nhomBoTieuChi?.botieuchi?.length > 0 &&
                                  nhomBoTieuChi?.botieuchi?.map((item) => {
                                    return (
                                      <li
                                        className={`${
                                          dataChamDiem?.botieuchi?.[item?.id]
                                            ?.id && "bg-gray-200"
                                        } w-full rounded-md border px-4 py-2 shadow-sm shadow-gray-300 text-base hover:bg-gray-200 pointer-events-none cursor-text`}
                                        key={item?.id + "tieuchi"}
                                      >
                                        <span className="mr-4">
                                          +{item?.diem} điểm
                                        </span>
                                        <span
                                          className={
                                            "font-semibold cursor-text"
                                          }
                                        >
                                          {item?.ten}
                                        </span>
                                      </li>
                                    );
                                  })}
                              </ol>
                            </div>
                          </div>
                          <div className="mt-2 mx-auto flex justify-center">
                            <Pagination
                              count={listNhomTieuChi?.length || 1}
                              color="standard"
                              page={pageQuestion[tab]?.[activeStep[tab]] || 0}
                              onChange={handleChangePage}
                            />
                          </div>
                        </MDBox>
                      ) : (
                        <div className="px-4 my-10 w-full text-center min-h-[260px]">
                          Đang cập nhập thông tin...
                        </div>
                      )}
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Button
                          color="inherit"
                          disabled={tab === 0 && activeStep[tab] === 0}
                          onClick={handleBack}
                          sx={{ mr: 1 }}
                          size="small"
                        >
                          Trở về
                        </Button>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button onClick={handleNext} size="small">
                          Tiếp theo
                        </Button>
                      </Box>
                    </Fragment>
                  </MDBox>
                )}
              </>
            )}
          </Box>
        </>
      )}
      <Footer />
    </DashboardLayout>
  );
}
export default DetailChamDiemCapTinh;
